// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"cfdaf99b","362":"ee535328","488":"1b1a7081","777":"403e0a27"}[chunkId] + ".chunk.js";
};